import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { IconComponent } from '@mitsubishi/shared/ui';

import { NgSelectModule } from '@ng-select/ng-select';

import { NewsSelectTagsComponent } from './news-select-tags.component';

@NgModule({
  declarations: [NewsSelectTagsComponent],
  imports: [CommonModule, NgSelectModule, FormsModule, CommonModule, ApmTranslatePipe, IconComponent, MatTooltip],
  exports: [NewsSelectTagsComponent],
})
export class NewsSelectTagsModule {}
